import { apiGet, apiPut } from "../apiClient";
import { AdminEmailPrefKey, AdminEmailPreferences } from "@eip/shared/types";

export type AdminEmailPreferencesResponse = {
  success: boolean;
  // Server returns the fully-resolved 7-key map (missing stored keys read as enabled)
  preferences: Record<AdminEmailPrefKey, boolean>;
};

export const getAdminEmailPreferences = () =>
  apiGet<AdminEmailPreferencesResponse>("/api/admins/email-preferences");

export const updateAdminEmailPreferences = (preferences: AdminEmailPreferences) =>
  apiPut<AdminEmailPreferencesResponse>("/api/admins/email-preferences", { preferences });
